<!--  -->
<template>
  <div>
    <!-- Please correct all issues noted below... -->
    <OnexDialog
      :type="'error'"
      :is-persistent="true"
      v-model="displayErrorDialogDuringSubmitClick"
      max-width="700"
      class="aboveDialog"
    >
      <template #title>
        <span>
          {{ $t('L_please_correct_all_issues_noted_below') }}
        </span>
      </template>
      <template #text>
        <slot>
          <!-- List of Issues -->
          <v-row
            v-if="
              (primaryInsured && beneficiaryPrimary.length === 0) ||
              (showSpouseSection && beneficiarySpouse.length === 0)
            "
            class="ma-0"
          >
            <!-- Please add at least 1 primary beneficiary...  -->
            <v-col cols="12" class="text-left">
              <p class="text-body-1 font-weight-regular">
                {{ $t('L_please_add_at_least_one_primary_beneficiary_for_the') }}
              </p>
            </v-col>
            <!-- Primary / Spouse Insured -->
            <v-col cols="12" class="text-left">
              <ul class="px-4">
                <li v-if="beneficiaryPrimary.length === 0">
                  {{ primaryInsured }}
                </li>
                <li v-if="showSpouseSection && beneficiarySpouse.length === 0">
                  {{ spouseInsured }}
                </li>
              </ul>
            </v-col>
          </v-row>

          <v-divider
            v-if="
              (primaryInsured && beneficiaryPrimary.length === 0) ||
              (showSpouseSection && beneficiarySpouse.length === 0)
            "
            class="my-4 heavyDivider"
          />
          <!-- The total beneficiary allocation must be -->
          <v-row justify="center" class="ma-0">
            <!-- Any of the 4 beneficiary is not 100% -->
            <v-col
              cols="12"
              class="text-left"
              v-if="
                beneficiariesTotalPrimaryContingent !== 100 ||
                (beneficiaryPrimaryContingent.length > 0 &&
                  beneficiariesTotalPrimaryPrimary !== 100) ||
                (showSpouseSection && beneficiariesTotalSpousePrimary !== 100) ||
                (showSpouseSection &&
                  beneficiarySpouseContingent.length > 0 &&
                  beneficiariesTotalSpouseContingent !== 100)
              "
            >
              {{ $t('L_the_total_beneficiary_allocation_must_be') }}
            </v-col>
            <!-- Allocation Percentage is a required... -->
            <v-col
              cols="12"
              class="text-left"
              v-if="
                invalidBeneficiaryPrimary ||
                invalidBeneficiaryPrimaryContingent ||
                invalidBeneficiarySpouse ||
                invalidBeneficiarySpouseContingent
              "
            >
              <div>{{ $t('L_allocation_percentage_required') }}</div>
              <div>{{ $t('L_allocation_percentage_zero_or_less') }}</div>
              <div>{{ $t('L_allocation_percentage_over_hundred') }}</div>
              <div>{{ $t('L_allocation_percentage_invalid_character') }}</div>
            </v-col>
          </v-row>
        </slot>
      </template>
      <template #yesBtn>
        <span @click="closeDialogForSubmitErrors">{{ $t('L_OK') }}</span>
      </template>
    </OnexDialog>
    <!-- This is for the V or T without Irrevocable-->
    <OnexDialog
      :type="'info'"
      :is-persistent="true"
      v-model="showOriginVorTwithNoIrrevocable"
      max-width="700"
      class="aboveDialog"
    >
      <template #title>
        <span>
          {{ $t('L_important_information_about_making_beneficiary_changes') }}
        </span>
      </template>
      <template #text>
        <slot>
          <p>
            {{
              $t('L_to_ensure_we_that_have_the_most_current_beneficiary_information_and_to_better')
            }}
          </p>
          <p class="pt-4 font-weight-bold">{{ $t('L_keep_these_key_points_in_mind') }}</p>
          <ul class="px-4 pt-4">
            <li class="mb-4">
              {{ $t('L_if_you_plan_to_keep_any_of_the_existing_beneficiaries_you_must') }}
            </li>
            <li class="mb-4">
              {{
                $t('L_if_you_do_not_enter_any_of_your_current_beneficiaries_they_will_be_removed')
              }}
            </li>
          </ul>
        </slot>
      </template>
      <template #yesBtn>
        <span @click="hideOriginVorTwithNoIrrevocable">{{ $t('L_ok_got_it') }}</span>
      </template>
    </OnexDialog>
    <!-- <v-dialog
      v-model="showOriginVorTwithNoIrrevocable"
      max-width="700"
      :persistent="true"
      :fullscreen="$vuetify.display.xs"
    >
      <v-card>
        <v-row class="py-0 mt-0" style="min-height: 0 !important; height: auto;">
          <v-col class="bluebar py-0"></v-col>
        </v-row>
        <v-row justify="end" style="min-height: 0 !important; height: auto;">
          <v-col cols="auto">
            <v-icon
              @click="hideOriginVorTwithNoIrrevocable"
              color="#000000"
              :icon="mdiClose"
              class="mr-3"
              style=""
            />
          </v-col>
        </v-row>
        <v-row class="mx-4">
          <v-col class="font-weight-bold text-center pl-0 pr-0" cols="12">
            <v-icon color="#3399ff" :icon="mdiInformation" />
            {{ $t('L_important_information_about_making_beneficiary_changes') }}
          </v-col>
          <v-col cols="12">
          </v-col>
        </v-row>
        <v-card-actions class="justify-center">
          <OnexButton
            class="px-4 mb-6"
            :class="$vuetify.display.xs ? 'buttonFormat_mobile' : 'buttonFormat'"
            color="primary"
            @click="hideOriginVorTwithNoIrrevocable"
          >
            <h3 class="text-h3 font-weight-bold">
              {{ $t('L_ok_got_it') }}
            </h3>
          </OnexButton>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <v-card class="pa-0 beneficiary-card">
      <MessageDialog
        :show-dialog="showMessageDialog"
        :has-button-two="true"
        type="warning"
        :title="$t('L_cancel_changes')"
        :message="$t('L_by_cancelling_no_change')"
        :button-two-label="$t('L_yes_cancel')"
        :button-one-label="$t('L_no_continue')"
        :is-persistent="true"
        @buttonTwoAction="closeThisPage"
        @buttonOneAction="showMessageDialog = false"
      />

      <WarningDialogBeneficiary
        v-if="showDeleteWarning"
        @hide-dialog="hideWarningDialog"
        :full-name="beneFullNameToDelete"
        @delete-beneficiary="deleteBeneficiary"
      />

      <!-- Title - Update Beneficiaries -->
      <v-card-title>
        <span role="heading" aria-level="2" :class="$vuetify.display.xs ? 'text-h2' : 'text-h1'">
          {{ $t('L_update_beneficiaries') }}
        </span>
      </v-card-title>

      <v-divider />

      <v-card-text>
        <!-- You can review, add or modify beneficiaries for each insured... -->
        <v-row
          class="ma-0"
          v-if="beneficiaryPrimary && fetchDataForVAndTPrimaryPrimary.length === 0"
        >
          <v-col class="px-0">
            <p>
              {{ $t('L_you_can_review_add_or_modify_v2') }}
            </p>
          </v-col>
        </v-row>
        <!-- For your reference, below is a list of the current beneficiaries... -->
        <v-row v-if="fetchDataForVAndTPrimaryPrimary && fetchDataForVAndTPrimaryPrimary.length > 0">
          <v-col cols="12">
            {{ $t('L_for_your_reference_below_is_a_list_of_the_current') }}
          </v-col>
          <v-col cols="auto" align-self="center" class="d-flex justify-start">
            <div>
              <v-img
                alt="icon report"
                src="../../PolicyMyPolicy/assets/tkn-icons-md-filled-ic-report.png"
                width="24px"
              />
            </div>
            <div
              class="ml-3"
              v-html="$t('L_remember_if_your_would_like_to_retain_any_of_the_beneficiaries')"
            ></div>
          </v-col>
        </v-row>
        <!-- Check out this guide... -->
        <v-row v-if="locale === 'en_US'">
          <v-col>
            <span @click="openGuide" class="font-weight-regular">
              {{ $t('L_check_out_this')
              }}<a
                @click="openGuide"
                target="_blank"
                style="cursor: pointer; text-decoration: underline"
                class="font-weight-bold"
                >{{ $t('L_guide_for_key_considerations') }}</a
              >{{ $t('for_key_considerations_when_naming_beneficiaries') }}
            </span>
          </v-col>
        </v-row>

        <!-- Click to Show v Displayed only for Data in T or V.  -->
        <div v-if="fetchDataForVAndTPrimaryPrimary && fetchDataForVAndTPrimaryPrimary.length > 0">
          <v-row class="grayBackground pa-4 ma-0">
            <v-col cols="12" sm="6" class="pl-0 pr-0">
              <p class="text-h3 font-weight-bold">{{ primaryInsured }}</p>
              <p class="text-body-1 font-weight-bold mt-4">{{ $t('L_Primary') }}</p>
              <p
                v-for="(obj, index) in fetchDataForVAndTPrimaryPrimary"
                :key="index + 'VTPrimaryPrimary'"
                class="text-body-1 font-weight-regular mt-4 mb-0"
              >
                {{ obj.fullName }}
              </p>
              <p class="text-body-1 font-weight-bold mt-4">{{ $t('L_Contingent') }}</p>
              <p
                v-for="(obj, index) in fetchDataForVAndTPrimaryContingent"
                :key="index + 'VTPrimaryContingent'"
                class="text-body-1 font-weight-regular mt-4"
              >
                {{ obj.fullName }}
              </p>
            </v-col>
            <v-col cols="12" sm="6">
              <v-row class="ma-0">
                <div
                  v-if="fetchDataForVAndTSpousePrimary && fetchDataForVAndTSpousePrimary.length > 0"
                >
                  <v-col cols="12" font-weight-bold mt-4 pt-4>
                    {{ spouseInsured }}
                  </v-col>
                  <v-col cols="12" font-size-14 font-weight-bold mt-2>
                    {{ $t('L_Primary') }}
                  </v-col>
                  <v-col
                    cols="12"
                    font-size-14
                    font-weight-regular
                    mt-2
                    v-for="(obj, index) in fetchDataForVAndTSpousePrimary"
                    :key="index + 'VTSpousePrimary'"
                  >
                    <span> {{ obj.fullName }} </span>
                  </v-col>
                  <v-col cols="12" font-size-14 font-weight-bold mt-4>
                    {{ $t('L_Contingent') }}
                  </v-col>
                  <v-col
                    cols="12"
                    v-for="(obj, index) in fetchDataForVAndTSpouseContingent"
                    :key="index + 'VTSpouseContingent'"
                  >
                    <span> {{ obj.fullName }} </span>
                  </v-col>
                </div>
              </v-row>
            </v-col>
          </v-row>
        </div>

        <!-- TODO: refactor reusable components common in both Primary and spouse -->
        <!--Primary - Primary Beneficiary Section -->
        <div v-if="primaryInsured && primaryInsured.length > 0">
          <!-- Insured: John J Doe -->
          <v-row class="ma-0">
            <v-col cols="12" class="pl-0 pr-0">
              <span class="font-size--20 font-weight-medium">
                {{ $t('L_policy_insured')
                }}<span class="font-weight-bold"> {{ ' ' + primaryInsured }}</span>
              </span>
            </v-col>
          </v-row>

          <!-- Table Header: Primary Beneficiary - Allocation % -->
          <div class="bottomBorderGray ma-0 mb-0 d-flex align-center">
            <!-- Primary Beneficiary  -->
            <p
              class="font-weight-bold text-left pb-2 pl-0 pr-2 d-inline header-title-width align-center"
            >
              {{ $t('L_primary_beneficiary') }}
              <!-- TODO: see offset -->
              <v-tooltip
                content-class="text-left"
                location="right"
                :offset="$vuetify.display.mdAndUp ? '50' : '70'"
                :max-width="$vuetify.display.mdAndUp ? '650' : '162'"
                v-model="primaryBeneficiaryTooltip"
                color="primary"
              >
                <template #activator="{ props }">
                  <v-icon
                    v-bind="props"
                    tabindex="0"
                    color="primary"
                    size="16"
                    class="pri-inline-icon cursor-pointer"
                    aria-label="coverage amount information"
                    @click.stop="primaryBeneficiaryTooltip = !primaryBeneficiaryTooltip"
                    @blur="primaryBeneficiaryTooltip = !primaryBeneficiaryTooltip"
                    @focus="primaryBeneficiaryTooltip = !primaryBeneficiaryTooltip"
                    :icon="mdiInformation"
                  />
                </template>
                <span role="tooltip" aria-live="polite" id="policy_number_tooltip">
                  <ul v-if="isCanadian">
                    {{
                      $t('L_the_primary_beneficiary_is_CA')
                    }}
                  </ul>
                  <ul v-else>
                    {{
                      $t('L_the_primary_beneficiary_is_US')
                    }}
                  </ul>
                  <ul v-if="isCanadian">
                    {{
                      $t('L_an_assignee_will_take_priority_CA')
                    }}
                  </ul>
                </span>
              </v-tooltip>
            </p>
            <!-- Allocation % -->
            <v-spacer></v-spacer>
            <p class="font-weight-bold text-left pb-2 pl-0 pr-0 allocation-percentage-width">
              {{ $t('L_allocation_percentage') }}
            </p>
          </div>

          <!-- NOTE: There must be at least one designated Primary beneficiary. -->
          <onex-alert
            v-if="beneficiaryPrimary && beneficiaryPrimary.length === 0"
            :type="Notifications.error"
            :dismissible="false"
            class="mb-4 beneficiary-note"
          >
            <span style="font-size: 14px !important; font-weight: 400 !important">
              <i18n-t
                keypath="L_note_there_must_be_at_lease_one_designated_primary_beneficiary"
                scope="global"
              >
                <template #note>
                  <b>{{ $t('L_note') }} &nbsp;</b>
                </template>
              </i18n-t>
            </span>
          </onex-alert>

          <!-- List of Beneficiary for Primary -->
          <div
            v-for="(beneficiary, index) in beneficiaryPrimary"
            :key="beneficiary.beneKeyId + 'primaryBeneficiary' + index"
            :class="(index as any) % 2 === 0 ? 'bkgrnd-color-blue-white' : 'bkgrnd-color-white'"
            align-content="center"
            class="ma-0 py-4 d-flex align-center"
          >
            <div class="text-left header-title-width">
              <span v-if="beneficiary.irrevocable">
                {{ getFullNameForDisplayWithLocale(beneficiary.fullName) }}
              </span>
              <span v-else @click="editBeneficiary(beneficiary)">
                <v-icon color="primary" class="text-decoration-none" :icon="mdiPencilOutline" />
                <span class="linkText">
                  {{ getFullNameForDisplayWithLocale(beneficiary.fullName) }}
                </span>
              </span>
            </div>
            <v-spacer></v-spacer>
            <!-- Allocation % -->
            <div
              class="text-left pl-0 pr-0 pt-0 pb-0 d-inline-flex align-center allocation-percentage-width"
            >
              <span
                v-if="
                  !beneficiary.irrevocable &&
                  (beneficiary.beneficiaryEntityType === 'X' ||
                    beneficiary.beneficiaryEntityType === 'Y')
                "
              >
                <OnexText
                  label=""
                  hideLabel
                  v-model="beneficiary.beneficiaryPercent"
                  :autocomplete="'off'"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  maxlength="3"
                  width="63px"
                  class="text-left px-0 mx-0 allocation-field"
                  :error-messages="
                    beneficiary.beneficiaryPercent === '0' ||
                    beneficiary.beneficiaryPercent === '' ||
                    parseInt(beneficiary.beneficiaryPercent) > 100 ||
                    parseInt(beneficiary.beneficiaryPercent) < 0
                      ? $t('L_number_between_1_and_100')
                      : null
                  "
                  @keydown="onKeyDown"
                  variant="solo"
                  suffix="%"
                  density="compact"
                />
              </span>
              <span v-else> {{ beneficiary.beneficiaryPercent }} % </span>

              <!-- trash can icon -->
              <v-spacer></v-spacer>
              <span v-if="beneficiary.irrevocable" class="ml-2">
                <v-icon :icon="mdiLockOutline" />
                <v-tooltip location="left" html="true" open-on-click close-delay="2000">
                  <template #activator="{ props }">
                    <sup>
                      <v-icon
                        v-bind="props"
                        color="primary"
                        size="small"
                        class="pri-inline-icon pl-1 cursor-pointer"
                        :icon="mdiInformation"
                      />
                    </sup>
                  </template>
                  <span>
                    <ul>
                      {{
                        $t('L_irrevocable_beneficiary_tooltip_one')
                      }}
                    </ul>
                    <ul>
                      {{
                        $t('L_irrevocable_beneficiary_tooltip_two')
                      }}
                    </ul>
                    <ul v-if="isCanadian">
                      {{
                        $t('L_irrevocable_beneficiary_tooltip_three')
                      }}
                    </ul>
                  </span>
                </v-tooltip>
              </span>
              <span
                v-else
                @click="
                  beneKeyIdToDelete = beneficiary.beneKeyId;
                  beneTypeToDelete = 'P';
                  showDeleteWarning = true;
                  beneFullNameToDelete = beneficiary.fullName;
                "
                class="ml-2"
              >
                <v-icon color="#04549c" :icon="mdiTrashCanOutline" />
              </span>
            </div>
          </div>

          <!-- <div class="dividerAboveTotal" /> -->
          <!-- Total Allocation % of Primary Beneficiary for Primary -->
          <div
            v-if="beneficiaryPrimary && beneficiaryPrimary.length > 0"
            :class="beneficiariesTotalPrimaryPrimary === 100 ? 'blue-bkgrnd' : 'red-bkgrnd'"
            class="py-2 ma-0 d-flex align-center"
          >
            <h2 class="text-h2 text-left font-weight-bold pl-6 py-0 header-title-width">
              {{ $t('L_total') }}
              <span class="mustEqual100Error" v-if="beneficiariesTotalPrimaryPrimary !== 100">
                {{ $t('L_must_equal_hundred') }}</span
              >
            </h2>
            <v-spacer></v-spacer>
            <h2
              class="text-h2 text-left font-weight-bold pr-2 py-0 allocation-percentage-width"
              :class="beneficiariesTotalPrimaryPrimary === 100 ? 'blackText' : 'redText'"
            >
              {{ beneficiariesTotalPrimaryPrimary }}%
              <span v-if="beneficiariesTotalPrimaryPrimary !== 100"
                ><v-icon color="#bc1f1f" :icon="mdiAlertCircle"
              /></span>
            </h2>
            <div>&nbsp;</div>
          </div>

          <!-- Add Primary Beneficiary -->
          <v-row class="ma-0">
            <v-col class="pl-0 pr-0">
              <a
                @click.prevent="addBeneficiaryDetails('P')"
                href=""
                class="text-decoration-none font-weight-bold"
              >
                <v-icon color="#04549c" class="mr-2" :icon="mdiPlusCircle" />
                <span color="#04549c">{{ $t('L_add_primary_beneficiary') }}</span>
              </a>
            </v-col>
          </v-row>

          <!-- Primary - Contingent Beneficiary Header -->
          <div class="bottomBorderGray ma-0 mb-0 d-flex align-center">
            <p
              class="font-weight-bold text-left pb-2 pl-0 pr-2 d-inline header-title-width align-center"
            >
              {{ $t('L_contingent_beneficiary') }}
              <!-- TODO: see offset -->
              <v-tooltip
                content-class="text-left"
                location="right"
                :offset="$vuetify.display.mdAndUp ? '50' : '70'"
                :max-width="$vuetify.display.mdAndUp ? '650' : '162'"
                v-model="primaryContingentBeneficiaryTooltip"
                color="primary"
              >
                <template #activator="{ props }">
                  <v-icon
                    v-bind="props"
                    tabindex="0"
                    color="primary"
                    size="16"
                    class="pri-inline-icon cursor-pointer"
                    aria-label="coverage amount information"
                    @click.stop="
                      primaryContingentBeneficiaryTooltip = !primaryContingentBeneficiaryTooltip
                    "
                    @blur="
                      primaryContingentBeneficiaryTooltip = !primaryContingentBeneficiaryTooltip
                    "
                    @focus="
                      primaryContingentBeneficiaryTooltip = !primaryContingentBeneficiaryTooltip
                    "
                    :icon="mdiInformation"
                  />
                </template>
                <span role="tooltip" aria-live="polite" id="policy_number_tooltip">
                  <ul v-if="isCanadian">
                    {{
                      $t('L_the_contingent_beneficiary_is_CA')
                    }}
                  </ul>
                  <ul v-else>
                    {{
                      $t('L_the_contingent_beneficiary_is_US')
                    }}
                  </ul>
                  <ul v-if="isCanadian">
                    {{
                      $t('L_contingent_beneficiaries_will_be_CA')
                    }}
                  </ul>
                </span>
              </v-tooltip>
            </p>
            <v-spacer></v-spacer>
            <p class="font-weight-bold text-left pb-2 pl-0 pr-0 allocation-percentage-width">
              {{ $t('L_allocation_percentage') }}
            </p>
          </div>

          <v-divider class="mb-0" />

          <!-- LIst of Primary - Contingent Beneficiary -->
          <div
            v-for="(beneficiary, index) in beneficiaryPrimaryContingent"
            :key="beneficiary.beneKeyId + 'primaryContingentBeneficiary' + index"
            :class="(index as any) % 2 === 0 ? 'bkgrnd-color-blue-white' : 'bkgrnd-color-white'"
            align-content="center"
            class="ma-0 py-4 d-flex align-center"
          >
            <div class="text-left header-title-width">
              <span v-if="beneficiary.irrevocable">
                {{ getFullNameForDisplayWithLocale(beneficiary.fullName) }}
              </span>
              <span v-else @click="editBeneficiary(beneficiary)">
                <v-icon color="primary" class="text-decoration-none" :icon="mdiPencilOutline" />
                <span class="linkText">
                  {{ getFullNameForDisplayWithLocale(beneficiary.fullName) }}
                </span>
              </span>
            </div>
            <v-spacer></v-spacer>
            <!-- Allocation % -->
            <div
              class="text-left pl-0 pr-0 pt-0 pb-0 d-inline-flex align-center allocation-percentage-width"
            >
              <span
                v-if="
                  !beneficiary.irrevocable &&
                  (beneficiary.beneficiaryEntityType === 'X' ||
                    beneficiary.beneficiaryEntityType === 'Y')
                "
              >
                <OnexText
                  label=""
                  hideLabel
                  v-model="beneficiary.beneficiaryPercent"
                  :autocomplete="'off'"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  maxlength="3"
                  width="63px"
                  class="text-left px-0 mx-0 allocation-field"
                  :error-messages="
                    beneficiary.beneficiaryPercent === '0' ||
                    beneficiary.beneficiaryPercent === '' ||
                    parseInt(beneficiary.beneficiaryPercent) > 100 ||
                    parseInt(beneficiary.beneficiaryPercent) < 0
                      ? $t('L_number_between_1_and_100')
                      : null
                  "
                  @keydown="onKeyDown"
                  persistent-hint
                  variant="solo"
                  suffix="%"
                  density="compact"
                />
              </span>
              <span v-else> {{ beneficiary.beneficiaryPercent }} % </span>

              <!-- trash can icon -->
              <v-spacer></v-spacer>
              <span v-if="beneficiary.irrevocable" class="ml-2">
                <v-icon :icon="mdiLockOutline" />
                <v-tooltip location="left" html="true" open-on-click close-delay="2000">
                  <template #activator="{ props }">
                    <sup>
                      <v-icon
                        v-bind="props"
                        color="primary"
                        size="small"
                        class="pri-inline-icon pl-1 cursor-pointer"
                        :icon="mdiInformation"
                      />
                    </sup>
                  </template>
                  <span>
                    <ul>
                      {{
                        $t('L_irrevocable_beneficiary_tooltip_one')
                      }}
                    </ul>
                    <ul>
                      {{
                        $t('L_irrevocable_beneficiary_tooltip_two')
                      }}
                    </ul>
                    <ul v-if="isCanadian">
                      {{
                        $t('L_irrevocable_beneficiary_tooltip_three')
                      }}
                    </ul>
                  </span>
                </v-tooltip>
              </span>
              <span
                v-else
                @click="
                  beneKeyIdToDelete = beneficiary.beneKeyId;
                  beneTypeToDelete = 'C';
                  showDeleteWarning = true;
                  beneFullNameToDelete = beneficiary.fullName;
                "
                class="ml-2"
              >
                <v-icon color="#04549c" :icon="mdiTrashCanOutline" />
              </span>
            </div>
          </div>

          <!-- <div class="dividerAboveTotal" /> -->
          <!-- Total Allocation % of Contingent Beneficiary for Primary -->
          <div
            v-if="beneficiaryPrimaryContingent && beneficiaryPrimaryContingent.length > 0"
            :class="beneficiariesTotalPrimaryContingent === 100 ? 'blue-bkgrnd' : 'red-bkgrnd'"
            class="py-2 ma-0 d-flex align-center"
          >
            <h2 class="text-h2 text-left font-weight-bold pl-6 py-0 header-title-width">
              {{ $t('L_total') }}
              <span class="mustEqual100Error" v-if="beneficiariesTotalPrimaryContingent !== 100">
                {{ $t('L_must_equal_hundred') }}</span
              >
            </h2>
            <v-spacer></v-spacer>
            <h2
              class="text-h2 text-left font-weight-bold pr-2 py-0 allocation-percentage-width"
              :class="beneficiariesTotalPrimaryContingent === 100 ? 'blackText' : 'redText'"
            >
              {{ beneficiariesTotalPrimaryContingent }}%
              <span v-if="beneficiariesTotalPrimaryContingent !== 100"
                ><v-icon color="#bc1f1f" :icon="mdiAlertCircle"
              /></span>
            </h2>
            <div>&nbsp;</div>
          </div>

          <!-- Primary - Add Contingent Beneficiary -->
          <v-row class="ma-0">
            <v-col class="pl-0 pr-0 pt-4">
              <a
                @click.prevent="addBeneficiaryDetails('C')"
                href=""
                class="text-decoration-none font-weight-bold"
              >
                <v-icon color="#04549c" class="mr-2" :icon="mdiPlusCircle" />
                <span color="#04549c">{{ $t('L_add_contingent_beneficiary') }}</span>
              </a>
            </v-col>
          </v-row>
        </div>

        <!-- TODO: refactor reusable components common in both Primary and spouse -->
        <!--Spouse - Primary Beneficiary Section -->
        <div v-if="showSpouseSection" class="mt-4">
          <!-- Insured: Jane J Doe -->
          <v-row class="ma-0">
            <v-col cols="12" class="pl-0">
              <h1 class="text-h2 font-weight-medium">
                {{ $t('L_policy_spouse_insured')
                }}<span class="font-weight-bold"> {{ ' ' + spouseInsured }}</span>
              </h1>
            </v-col>
          </v-row>

          <!-- Table Header: Primary Beneficiary - Allocation % -->
          <div class="bottomBorderGray ma-0 mb-0 d-flex align-center">
            <!-- Primary Beneficiary -->
            <p
              class="font-weight-bold text-left pb-2 pl-0 pr-2 d-inline header-title-width align-center flex-grow-1"
            >
              {{ $t('L_primary_beneficiary') }}
              <!-- TODO: see offset -->
              <v-tooltip
                content-class="text-left"
                location="right"
                :offset="$vuetify.display.mdAndUp ? '50' : '70'"
                :max-width="$vuetify.display.mdAndUp ? '650' : '162'"
                v-model="spousePrimaryBeneficiaryTooltip"
                color="primary"
              >
                <template #activator="{ props }">
                  <v-icon
                    v-bind="props"
                    tabindex="0"
                    color="primary"
                    size="16"
                    class="pri-inline-icon cursor-pointer"
                    aria-label="coverage amount information"
                    @click.stop="spousePrimaryBeneficiaryTooltip = !spousePrimaryBeneficiaryTooltip"
                    @blur="spousePrimaryBeneficiaryTooltip = !spousePrimaryBeneficiaryTooltip"
                    @focus="spousePrimaryBeneficiaryTooltip = !spousePrimaryBeneficiaryTooltip"
                    :icon="mdiInformation"
                  />
                </template>
                <span role="tooltip" aria-live="polite" id="policy_number_tooltip">
                  <ul v-if="isCanadian">
                    {{
                      $t('L_the_primary_beneficiary_is_CA')
                    }}
                  </ul>
                  <ul v-else>
                    {{
                      $t('L_the_primary_beneficiary_is_US')
                    }}
                  </ul>
                  <ul v-if="isCanadian">
                    {{
                      $t('L_an_assignee_will_take_priority_CA')
                    }}
                  </ul>
                </span>
              </v-tooltip>
            </p>
            <!-- Allocation % -->
            <p class="font-weight-bold text-left pb-2 pl-0 pr-0 allocation-percentage-width">
              {{ $t('L_allocation_percentage') }}
            </p>
          </div>
          <!-- NOTE: There must be at least one designated Primary beneficiary. -->
          <onex-alert
            v-if="showSpouseSection && beneficiarySpouse.length === 0"
            :type="Notifications.error"
            :dismissible="false"
            class="mb-4 beneficiary-note"
          >
            <span style="font-size: 14px !important; font-weight: 400 !important">
              <i18n-t
                keypath="L_note_there_must_be_at_lease_one_designated_primary_beneficiary"
                scope="global"
              >
                <template #note>
                  <b>{{ $t('L_note') }} &nbsp;</b>
                </template>
              </i18n-t>
            </span>
          </onex-alert>

          <!-- List of Beneficiary for Spouse -->
          <div
            v-for="(beneficiary, index) in beneficiarySpouse"
            :key="beneficiary.beneKeyId + 'primaryBeneficiary' + index"
            :class="(index as any) % 2 === 0 ? 'bkgrnd-color-blue-white' : 'bkgrnd-color-white'"
            align-content="center"
            class="ma-0 py-4 d-flex align-center"
          >
            <div class="text-left header-title-width">
              <span v-if="beneficiary.irrevocable">
                {{ getFullNameForDisplayWithLocale(beneficiary.fullName) }}
              </span>
              <span v-else @click="editBeneficiary(beneficiary)">
                <v-icon color="primary" class="text-decoration-none" :icon="mdiPencilOutline" />
                <span class="linkText">
                  {{ getFullNameForDisplayWithLocale(beneficiary.fullName) }}
                </span>
              </span>
            </div>
            <v-spacer></v-spacer>
            <!-- Allocation % -->
            <div
              class="text-left pl-0 pr-0 pt-0 pb-0 d-inline-flex align-center allocation-percentage-width"
            >
              <span
                v-if="
                  !beneficiary.irrevocable &&
                  (beneficiary.beneficiaryEntityType === 'X' ||
                    beneficiary.beneficiaryEntityType === 'Y')
                "
              >
                <OnexText
                  label=""
                  hideLabel
                  v-model="beneficiary.beneficiaryPercent"
                  :autocomplete="'off'"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  maxlength="3"
                  width="63px"
                  class="text-left px-0 mx-0 allocation-field"
                  :error-messages="
                    beneficiary.beneficiaryPercent === '0' ||
                    beneficiary.beneficiaryPercent === '' ||
                    parseInt(beneficiary.beneficiaryPercent) > 100 ||
                    parseInt(beneficiary.beneficiaryPercent) < 0
                      ? $t('L_number_between_1_and_100')
                      : null
                  "
                  @keydown="onKeyDown"
                  persistent-hint
                  variant="solo"
                  suffix="%"
                  density="compact"
                />
              </span>
              <span v-else> {{ beneficiary.beneficiaryPercent }} % </span>

              <!-- trash can icon -->
              <v-spacer></v-spacer>
              <span v-if="beneficiary.irrevocable" class="ml-2">
                <v-icon :icon="mdiLockOutline" />
                <v-tooltip location="left" html="true" open-on-click close-delay="2000">
                  <template #activator="{ props }">
                    <sup>
                      <v-icon
                        v-bind="props"
                        color="primary"
                        size="small"
                        class="pri-inline-icon pl-1 cursor-pointer"
                        :icon="mdiInformation"
                      />
                    </sup>
                  </template>
                  <span>
                    <ul>
                      {{
                        $t('L_irrevocable_beneficiary_tooltip_one')
                      }}
                    </ul>
                    <ul>
                      {{
                        $t('L_irrevocable_beneficiary_tooltip_two')
                      }}
                    </ul>
                    <ul v-if="isCanadian">
                      {{
                        $t('L_irrevocable_beneficiary_tooltip_three')
                      }}
                    </ul>
                  </span>
                </v-tooltip>
              </span>
              <span
                v-else
                @click="
                  beneKeyIdToDelete = beneficiary.beneKeyId;
                  beneTypeToDelete = 'S';
                  showDeleteWarning = true;
                  beneFullNameToDelete = beneficiary.fullName;
                "
                class="ml-2"
              >
                <v-icon color="#04549c" :icon="mdiTrashCanOutline" />
              </span>
            </div>
          </div>

          <!-- <div class="dividerAboveTotal" /> -->
          <!-- Total Allocation % of Primary Beneficiary for Primary -->
          <div
            v-if="showSpouseSection && beneficiarySpouse.length > 0"
            :class="beneficiariesTotalSpousePrimary === 100 ? 'blue-bkgrnd' : 'red-bkgrnd'"
            class="py-2 ma-0 d-flex align-center"
          >
            <h2 class="text-h2 text-left font-weight-bold pl-6 py-0 header-title-width">
              {{ $t('L_total') }}
              <span
                class="font-weight-bold mustEqual100Error"
                v-if="beneficiariesTotalSpousePrimary !== 100"
              >
                {{ $t('L_must_equal_hundred') }}</span
              >
            </h2>
            <v-spacer></v-spacer>
            <h2
              class="text-h2 text-left font-weight-bold pr-2 py-0 allocation-percentage-width"
              :class="beneficiariesTotalSpousePrimary === 100 ? 'blackText' : 'redText'"
            >
              {{ beneficiariesTotalSpousePrimary }}%
              <span v-if="beneficiariesTotalSpousePrimary !== 100"
                ><v-icon color="#bc1f1f" :icon="mdiAlertCircle"
              /></span>
            </h2>
            <div>&nbsp;</div>
          </div>

          <!-- Spouse - Add Primary Beneficiary -->
          <v-row class="ma-0">
            <v-col class="pl-0 pr-0">
              <a
                @click.prevent="addBeneficiaryDetails('S')"
                href=""
                class="text-decoration-none font-weight-bold"
              >
                <v-icon color="#04549c" class="mr-2" :icon="mdiPlusCircle" />
                <span color="#04549c">{{ $t('L_add_primary_beneficiary') }}</span>
              </a>
            </v-col>
          </v-row>

          <!-- Spouse - Contingent Beneficiary Header -->
          <div class="bottomBorderGray ma-0 mb-0 d-flex align-center">
            <p
              class="font-weight-bold text-left pb-2 pl-0 pr-2 d-inline header-title-width align-center flex-grow-1"
            >
              {{ $t('L_contingent_beneficiary') }}
              <!-- TODO: see offset -->
              <v-tooltip
                content-class="text-left"
                location="right"
                :offset="$vuetify.display.mdAndUp ? '50' : '70'"
                :max-width="$vuetify.display.mdAndUp ? '650' : '162'"
                v-model="spouseContingentBeneficiaryTooltip"
                color="primary"
              >
                <template #activator="{ props }">
                  <v-icon
                    v-bind="props"
                    tabindex="0"
                    color="primary"
                    size="16"
                    class="pri-inline-icon cursor-pointer"
                    aria-label="coverage amount information"
                    @click.stop="
                      spouseContingentBeneficiaryTooltip = !spouseContingentBeneficiaryTooltip
                    "
                    @blur="spouseContingentBeneficiaryTooltip = !spouseContingentBeneficiaryTooltip"
                    @focus="
                      spouseContingentBeneficiaryTooltip = !spouseContingentBeneficiaryTooltip
                    "
                    :icon="mdiInformation"
                  />
                </template>
                <span role="tooltip" aria-live="polite" id="policy_number_tooltip">
                  <ul v-if="isCanadian">
                    {{
                      $t('L_the_contingent_beneficiary_is_CA')
                    }}
                  </ul>
                  <ul v-else>
                    {{
                      $t('L_the_contingent_beneficiary_is_US')
                    }}
                  </ul>
                  <ul v-if="isCanadian">
                    {{
                      $t('L_contingent_beneficiaries_will_be_CA')
                    }}
                  </ul>
                </span>
              </v-tooltip>
            </p>
            <p class="font-weight-bold text-left pb-2 pl-0 pr-0 allocation-percentage-width">
              {{ $t('L_allocation_percentage') }}
            </p>
          </div>

          <v-divider class="mb-0" />

          <!-- List of Spouse - Contingent Beneficiary -->
          <div
            v-for="(beneficiary, index) in beneficiarySpouseContingent"
            :key="beneficiary.beneKeyId + 'primaryContingentBeneficiary' + index"
            :class="(index as any) % 2 === 0 ? 'bkgrnd-color-blue-white' : 'bkgrnd-color-white'"
            align-content="center"
            class="ma-0 py-4 d-flex align-center"
          >
            <div class="text-left header-title-width">
              <span v-if="beneficiary.irrevocable">
                {{ getFullNameForDisplayWithLocale(beneficiary.fullName) }}
              </span>
              <span v-else @click="editBeneficiary(beneficiary)">
                <v-icon color="primary" class="text-decoration-none" :icon="mdiPencilOutline" />
                <span class="linkText">
                  {{ getFullNameForDisplayWithLocale(beneficiary.fullName) }}
                </span>
              </span>
            </div>
            <v-spacer></v-spacer>
            <!-- Allocation % -->
            <div
              class="text-left pl-0 pr-0 pt-0 pb-0 d-inline-flex align-center allocation-percentage-width"
            >
              <span
                v-if="
                  !beneficiary.irrevocable &&
                  (beneficiary.beneficiaryEntityType === 'X' ||
                    beneficiary.beneficiaryEntityType === 'Y')
                "
              >
                <OnexText
                  label=""
                  hideLabel
                  v-model="beneficiary.beneficiaryPercent"
                  :autocomplete="'off'"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  maxlength="3"
                  width="63px"
                  class="text-left px-0 mx-0 allocation-field"
                  :error-messages="
                    beneficiary.beneficiaryPercent === '0' ||
                    beneficiary.beneficiaryPercent === '' ||
                    parseInt(beneficiary.beneficiaryPercent) > 100 ||
                    parseInt(beneficiary.beneficiaryPercent) < 0
                      ? $t('L_number_between_1_and_100')
                      : null
                  "
                  @keydown="onKeyDown"
                  persistent-hint
                  variant="solo"
                  suffix="%"
                  density="compact"
                />
              </span>
              <span v-else> {{ beneficiary.beneficiaryPercent }} % </span>

              <!-- trash can icon -->
              <v-spacer></v-spacer>
              <span v-if="beneficiary.irrevocable" class="ml-2">
                <v-icon :icon="mdiLockOutline" />
                <v-tooltip location="left" html="true" open-on-click close-delay="2000">
                  <template v-slot:activator="{ props }">
                    <sup>
                      <v-icon
                        v-bind="props"
                        color="primary"
                        size="small"
                        class="pri-inline-icon pl-1 cursor-pointer"
                        :icon="mdiInformation"
                      />
                    </sup>
                  </template>
                  <span>
                    <ul>
                      {{
                        $t('L_irrevocable_beneficiary_tooltip_one')
                      }}
                    </ul>
                    <ul>
                      {{
                        $t('L_irrevocable_beneficiary_tooltip_two')
                      }}
                    </ul>
                    <ul v-if="isCanadian">
                      {{
                        $t('L_irrevocable_beneficiary_tooltip_three')
                      }}
                    </ul>
                  </span>
                </v-tooltip>
              </span>
              <span
                v-else
                @click="
                  beneKeyIdToDelete = beneficiary.beneKeyId;
                  beneTypeToDelete = 'H';
                  showDeleteWarning = true;
                  beneFullNameToDelete = beneficiary.fullName;
                "
                class="ml-2"
              >
                <v-icon color="#04549c" :icon="mdiTrashCanOutline" />
              </span>
            </div>
          </div>

          <!-- <div class="dividerAboveTotal" /> -->
          <!-- Total Allocation % of Contingent Beneficiary for Spouse -->
          <div
            v-if="beneficiarySpouseContingent && beneficiarySpouseContingent.length > 0"
            :class="beneficiariesTotalSpouseContingent === 100 ? 'blue-bkgrnd' : 'red-bkgrnd'"
            class="py-2 ma-0 d-flex align-center"
          >
            <h2 class="text-h2 text-left font-weight-bold pl-6 py-0 header-title-width">
              {{ $t('L_total') }}
              <span class="mustEqual100Error" v-if="beneficiariesTotalSpouseContingent !== 100">
                {{ $t('L_must_equal_hundred') }}</span
              >
            </h2>
            <v-spacer></v-spacer>
            <h2
              class="text-h2 text-left font-weight-bold pr-2 py-0 allocation-percentage-width"
              :class="beneficiariesTotalSpouseContingent === 100 ? 'blackText' : 'redText'"
            >
              {{ beneficiariesTotalSpouseContingent }}%
              <span v-if="beneficiariesTotalSpouseContingent !== 100"
                ><v-icon color="#bc1f1f" :icon="mdiAlertCircle"
              /></span>
            </h2>
            <div>&nbsp;</div>
          </div>

          <!-- Spouse - Add Contingent Beneficiary -->
          <v-row class="ma-0">
            <v-col class="pl-0 pr-0">
              <a
                @click.prevent="addBeneficiaryDetails('H')"
                href=""
                class="text-decoration-none font-weight-bold"
              >
                <v-icon color="#04549c" class="mr-2" :icon="mdiPlusCircle" />
                <span color="#04549c">{{ $t('L_add_contingent_beneficiary') }}</span>
              </a>
            </v-col>
          </v-row>
        </div>

        <!-- Disclaimer below Beneficiary Section -->
        <v-divider color="#ffffff" />

        <div>
          <v-row class="ma-0 mt-4">
            <v-col class="px-0 font-size--14">
              <v-icon class="mr-2" color="rgba(0,0,0,0.34)" :icon="mdiLockOutline" />
              <span class="font-weight-bold" v-html="$t('L_Note')" />
              <span class="font-size--14">
                {{
                  ' ' + $t('L_beneficiaries_with_this_icon_represent_an_irrevocable_beneficiary')
                }}
                {{ $t('L_an_irrevocable_beneficiary') }}
                {{ $t('L_the_only_time_rights_can') }}
                {{ $t('L_the_irrevocable_beneficiary_is') }}
                {{ $t('L_to_change_the_status_of_an_irrevocable_beneficiary_please_complete') }}
                <span @click="openIrrevocableChangeForm" class="help-link">{{
                  $t('L_irrevocable_beneficiary_designation_and_change_form')
                }}</span>
              </span>
            </v-col>
          </v-row>
          <v-row class="my-4">
            <v-col cols="12">
              <span class="font-size--14 font-weight-regular">
                {{ $t('L_the_above_beneficiaries_will_be_recorded') }}
                <span @click="openIrrevocableChangeForm" class="help-link">{{
                  $t('L_irrevocable_beneficiary_designation_and_change_form')
                }}</span>
              </span>
              <div v-if="locale === 'fr_CA' || locale === 'en_CA'" class="font-size--14 pt-4">
                {{ $t('L_in_quebec_all_spouses_who_are_designated_a_beneficiary_are') }}
              </div>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col pt-4 pb-4 text-center font-size--14>
              <span>{{ $t('L_if_you_need_assistance_please_visit') }}</span>
              <span @click="openHelp" class="help-link">{{ $t('L_help') }}</span>
              <span>{{ $t('L_section') }}</span>
            </v-col>
          </v-row> -->
          <!-- <v-row>
            <v-col pb-4 mt-4 mb-4 :class="$vuetify.display.xs?'':'padding-space-left-40'">
              <span v-html="$t('L_please_request_a_paper_beneficiary_designation_from_your_servicing_representative', {custPhone:customerServicePhoneNum})">&nbsp;</span>
            </v-col>
          </v-row> -->
        </div>
      </v-card-text>

      <!-- Action Buttons -->
      <v-card-actions>
        <v-row class="d-flex align-center justify-center pb-4 mx-0">
          <v-col cols="12" sm="6" md="4" class="pr-4">
            <OnexButton block variant="outlined" color="primary" @click="showMessageDialog = true">
              {{ $t('L_cancel') }}
            </OnexButton>
          </v-col>
          <v-col cols="12" sm="6" md="4" class="pr-4">
            <OnexButton block color="primary" @click="submitChanges">
              {{ $t('L_review_changes') }}
            </OnexButton>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
// import { required, maxLength } from '@vuelidate/validators';
import { openInNewWindow } from '@/mixins/openNewWindow';
import MessageDialog from '@/components/MessageDialog.vue';
import WarningDialogBeneficiary from './WarningDialogBeneficiary.vue';
import DynatraceClient from '@/plugins/dynatracePlugin';
import { mapActions, mapState, mapStores } from 'pinia';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { useGlobalStore } from '@/stores/global/global.store';
import { useCustomerStore } from '@/stores/customer/customer.store';
import bff from '@/shared/api/bff';
import type { IGetBeneficiariesResponse } from '@/shared/api/models.bff';
import type { IPolicyStoreBeneficiaryInfo } from '../../store/policyStore.model';
import {
  mdiClose,
  mdiAlertCircle,
  mdiHelpCircleOutline,
  mdiInformation,
  mdiLockOutline,
  mdiPencilOutline,
  mdiPlusCircle,
  mdiTrashCanOutline,
} from '@mdi/js';
import { OnexButton, OnexText, OnexDialog, OnexAlert, Notifications } from '@primerica/onex-ui-lib';
import { RouteNames } from '@/router/routeNames';
import { CapacitorFacade } from '@/plugins/capacitorPlugin';

const componentOptions: ComponentOptions = {
  name: 'MyBeneficiary',
  components: {
    WarningDialogBeneficiary,
    MessageDialog,
    OnexButton,
    OnexText,
    OnexDialog,
    OnexAlert,
  },
  emits: ['set-type', 'set-beneficiary'],
  data: () => ({
    showCurrentListForTandV: false,
    editing: false,
    showEditContactInfo: false,
    showDeleteWarning: false,
    beneKeyIdToDelete: 0,
    beneTypeToDelete: '',
    beneFullNameToDelete: '',
    displayErrorDialogDuringSubmitClick: false,
    persistent: true,
    showOriginVorTwithNoIrrevocable: false,
    showMessageDialog: false,
    primaryBeneficiaryTooltip: false,
    primaryContingentBeneficiaryTooltip: false,
    spousePrimaryBeneficiaryTooltip: false,
    spouseContingentBeneficiaryTooltip: false,
    mdiLockOutline,
    mdiPlusCircle,
    mdiInformation,
    mdiClose,
    mdiPencilOutline,
    mdiTrashCanOutline,
    mdiHelpCircleOutline,
    mdiAlertCircle,
    Notifications,
  }),
  mixins: [openInNewWindow],
  props: {
    comingFromEditBeneficiary: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapStores(usePolicyStore, useGlobalStore),
    ...mapState(useCustomerStore, ['customerProfile']),
    ...mapState(useGlobalStore, { locale: 'getLocale' }),
    ...mapState(usePolicyStore, {
      selectedPolicyIndex: 'selectedPolicyIndex',
      policyData: 'currentPolicy',
      beneficiaries: 'beneficiaries',
      beneficiaryPrimary: 'beneficiaryPrimary',
      beneficiaryPrimaryContingent: 'beneficiaryPrimaryContingent',
      beneficiarySpouse: 'beneficiarySpouse',
      beneficiarySpouseContingent: 'beneficiarySpouseContingent',
      beneficiariesTotalPrimaryPrimary: 'beneficiariesTotalPrimaryPrimary',
      beneficiariesTotalPrimaryContingent: 'beneficiariesTotalPrimaryContingent',
      beneficiariesTotalSpousePrimary: 'beneficiariesTotalSpousePrimary',
      beneficiariesTotalSpouseContingent: 'beneficiariesTotalSpouseContingent',
      // showSpouseSection: 'showSpouseSection',
      fetchDataForVAndTPrimaryPrimary: 'fetchDataForVAndTPrimaryPrimary',
      fetchDataForVAndTPrimaryContingent: 'fetchDataForVAndTPrimaryContingent',
      fetchDataForVAndTSpousePrimary: 'fetchDataForVAndTSpousePrimary',
      fetchDataForVAndTSpouseContingent: 'fetchDataForVAndTSpouseContingent',

      /*
      addressVerification: 'addressVerification',
      addressUpdateSuccess: 'addressUpdateSuccess',
      */
      policyOwner: 'policyOwner',
      currentPolicy: 'currentPolicy',
      contactDetailsPanel: 'contactDetailsPanel',
      editContactInfo: 'editContactInfo',
      policies: 'policies',
      beneficiaryStep: 'beneficiaryStep',
      beneficiaryHasOriginVorTWithIrrevocable: 'beneficiaryHasOriginVorTWithIrrevocable',
      beneficiaryHasOriginVorT: 'beneficiaryHasOriginVorT',
      isBeneficiaryDataDirty: 'isBeneficiaryDataDirty',
    }),
    isCanadian() {
      return this.currentPolicy?.isCanadaPolicy;
    },
    countryToUse() {
      if (this.isCanadian) {
        return 'CA';
      }
      return 'US';
    },
    invalidBeneficiaryPrimary() {
      if (this.beneficiaryPrimary && this.beneficiaryPrimary.length > 0) {
        return (
          this.beneficiaryPrimary.filter(
            (obj: IPolicyStoreBeneficiaryInfo) =>
              obj.beneficiaryPercent === '' ||
              obj.beneficiaryPercent === '0' ||
              parseInt(String(obj.beneficiaryPercent), 10) <= 0 ||
              parseInt(String(obj.beneficiaryPercent), 10) > 100
          ).length > 0
        );
      }
      return false;
    },
    invalidBeneficiaryPrimaryContingent() {
      if (this.beneficiaryPrimaryContingent && this.beneficiaryPrimaryContingent.length > 0) {
        return (
          this.beneficiaryPrimaryContingent.filter(
            (obj: IPolicyStoreBeneficiaryInfo) =>
              obj.beneficiaryPercent === '' ||
              obj.beneficiaryPercent === '0' ||
              parseInt(String(obj.beneficiaryPercent), 10) <= 0 ||
              parseInt(String(obj.beneficiaryPercent), 10) > 100
          ).length > 0
        );
      }
      return false;
    },
    invalidBeneficiarySpouse() {
      if (this.showSpouseSection) {
        return (
          this.beneficiarySpouse.filter(
            (obj: IPolicyStoreBeneficiaryInfo) =>
              obj.beneficiaryPercent === '' ||
              obj.beneficiaryPercent === '0' ||
              parseInt(String(obj.beneficiaryPercent), 10) <= 0 ||
              parseInt(String(obj.beneficiaryPercent), 10) > 100
          ).length > 0
        );
      }
      return false;
    },
    invalidBeneficiarySpouseContingent() {
      if (this.beneficiarySpouseContingent && this.beneficiarySpouseContingent.length > 0) {
        return (
          this.beneficiarySpouseContingent.filter(
            (obj: IPolicyStoreBeneficiaryInfo) =>
              obj.beneficiaryPercent === '' ||
              obj.beneficiaryPercent === '0' ||
              parseInt(String(obj.beneficiaryPercent), 10) <= 0 ||
              parseInt(String(obj.beneficiaryPercent), 10) > 100
          ).length > 0
        );
      }
      return false;
    },
    showSpouseSection() {
      if (this.policyData?.data?.spouseFirstName) {
        return `${this.policyData?.data?.spouseFirstName} ${this.policyData?.data?.spouseLastName}`;
      }
      return '';
    },
    primaryInsured() {
      return `${this.currentPolicy?.primaryInsured?.firstName} ${this.currentPolicy?.primaryInsured?.lastName}`;
    },
    spouseInsured() {
      if (this.currentPolicy?.data?.spouseLastName) {
        return `${this.currentPolicy?.data?.spouseFirstName} ${this.currentPolicy?.data?.spouseLastName}`;
      }
      return this.$t('L_policy_beneficiaries_spouse');
    },
    disablebutton() {
      const disableButton = false;
      return disableButton;
    },
    customerServicePhoneNum() {
      if (this.locale === 'en_US') {
        return '(800) 257-4725';
      } else if (this.locale === 'en_CA') {
        return '(800) 387-7876';
      } else if (this.locale === 'fr_CA') {
        return '(800) 265-4804';
      }
      return '(800) 257-4725';
    },
    howToChooseBeneficiariesLetter() {
      return 'https://assets.contentstack.io/v3/assets/blta73ea17d36c39575';
    },
    isMobile() {
      return CapacitorFacade.isNativePlatform();
    },
  },
  methods: {
    ...mapActions(usePolicyStore, {
      setBeneficiaryStep: 'setBeneficiaryStep',
      setBeneficiaryPrimary: 'setBeneficiaryPrimary',
      setBeneficiaryPrimaryContingent: 'setBeneficiaryPrimaryContingent',
      setBeneficiarySpouse: 'setBeneficiarySpouse',
      setBeneficiarySpouseContingent: 'setBeneficiarySpouseContingent',
    }),
    onKeyDown(e: KeyboardEvent) {
      // backspace, tab, arrow keys, insert, delete,
      // number on top of keyboard,  number on numpad
      if (
        e.keyCode === 8 ||
        e.keyCode === 9 ||
        (e.keyCode >= 35 && e.keyCode <= 46) ||
        (e.keyCode >= 48 && e.keyCode <= 57) ||
        (e.keyCode >= 96 && e.keyCode <= 105)
      ) {
        if (
          e.key !== '!' &&
          e.key !== '@' &&
          e.key !== '#' &&
          e.key !== '$' &&
          e.key !== '%' &&
          e.key !== '^' &&
          e.key !== '&' &&
          e.key !== '*' &&
          e.key !== '(' &&
          e.key !== ')'
        ) {
          // Above is to ensure that when space is being pressed it returns same keycode as numbers so we need
          // to look at the key to make sure that the keys are not special characters laid on top of the numbers
          return; // 0-9 only
        }
        e.preventDefault();
      }
      e.preventDefault();
    },
    openIrrevocableChangeForm() {
      if (this.locale === 'fr_CA') {
        window.open(window.appConfig.life.Canada_French_Irrevocable_change_form, '_blank');
      } else if (this.locale === 'en_CA') {
        window.open(window.appConfig.life.Canada_English_Irrevocable_change_form, '_blank');
      } else {
        window.open(window.appConfig.life.US_Irrevocable_change_form, '_blank');
      }
    },
    async openGuide() {
      if (this.locale === 'fr_CA') {
        await this.openInNewWindow({
          url: 'https://assets.contentstack.io/v3/assets/blt1dedeb682e8df2a2/blt972a3c22b7e1ff57/How_to_choose_beneficiaries_letter.pdf',
          target: '_blank',
        });
      } else {
        await this.openInNewWindow({
          url: 'https://assets.contentstack.io/v3/assets/blt1dedeb682e8df2a2/blt453e8a85ee22ed66/How_to_Choose_Beneficiaries_Letter.pdf',
          target: '_blank',
        });
      }
    },
    getFullNameForDisplayWithLocale(fullName: string) {
      let retFullName = fullName;
      if (this.locale === 'fr_CA' || this.locale === 'es_US') {
        if (fullName === 'Estate') {
          retFullName = this.$t('L_estate');
        } else if (fullName === 'All Children Equally') {
          retFullName = this.$t('L_all_children_equally');
        } else {
          return retFullName;
        }
      }
      return retFullName;
    },
    closeDialogForSubmitErrors() {
      this.displayErrorDialogDuringSubmitClick = false;
    },
    async openHelp() {
      const helpUrl = await bff.getRightAnswersHelpUrl();
      const url =
        'https://primerica.rightanswers.com/portal/app/portlets/results/viewsolution.jsp?solutionid=220328133937970&';
      // Current data returned as we are grabbing everything after ss? and appending to our url above which should end in '&'
      //  "URL":"https://primericastg.rightanswers.com/portal/ss?companycode=primerica&tabid=2&authID=primericaJwt&group=Client Portal&jwtoken=eyJ0eXAiOiJKV1QiLA0KICJhbGc"
      const finalDestination = encodeURI(url + helpUrl.data?.URL.split('ss?')[1]);
      await this.openInNewWindow({ url: finalDestination, target: 'RADashboardWinName' });
    },
    addBeneficiaryDetails(beneficiaryType: string) {
      this.$emit('set-type', beneficiaryType);
      this.policyStore.beneficiaryStep = 2;
      try {
        const tempDynatraceString = `PC2_UpdateBenf_Add_Policynum-${this.currentPolicy?.contractId}_BeneficiaryType-${this.beneTypeToDelete}`;
        // const tempStr = 'PC2_UpdateBenf_Edit_Policynum-' + <policy>_BeneficiaryType-[P,C,S,H]_Name-<Full Name - first 30 characters, replace spaces with underlines>
        const i = DynatraceClient.enterAction(tempDynatraceString);
        DynatraceClient.leaveAction(i);
      } catch (_error) {
        /* empty */
      }
    },
    deleteBeneficiary() {
      const beneId = this.beneKeyIdToDelete;
      const beneType = this.beneTypeToDelete;
      let beneObjToDel = null;
      let currBenef = null;
      if (beneType === 'P') {
        currBenef = this.beneficiaryPrimary.filter(
          (ben: IGetBeneficiariesResponse) => ben.beneKeyId !== beneId
        );
        beneObjToDel = this.beneficiaryPrimary.filter(
          (ben: IGetBeneficiariesResponse) => ben.beneKeyId === beneId
        );
      } else if (beneType === 'C') {
        currBenef = this.beneficiaryPrimaryContingent.filter(
          (ben: IGetBeneficiariesResponse) => ben.beneKeyId !== beneId
        );
        beneObjToDel = this.beneficiaryPrimaryContingent.filter(
          (ben: IGetBeneficiariesResponse) => ben.beneKeyId === beneId
        );
      } else if (beneType === 'S') {
        currBenef = this.beneficiarySpouse.filter(
          (ben: IGetBeneficiariesResponse) => ben.beneKeyId !== beneId
        );
        beneObjToDel = this.beneficiarySpouse.filter(
          (ben: IGetBeneficiariesResponse) => ben.beneKeyId === beneId
        );
      } else if (beneType === 'H') {
        currBenef = this.beneficiarySpouseContingent.filter(
          (ben: IGetBeneficiariesResponse) => ben.beneKeyId !== beneId
        );
        beneObjToDel = this.beneficiarySpouseContingent.filter(
          (ben: IGetBeneficiariesResponse) => ben.beneKeyId === beneId
        );
      }
      if (currBenef !== null) {
        if (beneType === 'P') {
          this.policyStore.beneficiaryPrimary = currBenef;
        } else if (beneType === 'C') {
          this.policyStore.beneficiaryPrimaryContingent = currBenef;
        } else if (beneType === 'S') {
          this.policyStore.beneficiarySpouse = currBenef;
        } else if (beneType === 'H') {
          this.policyStore.beneficiarySpouseContingent = currBenef;
        }
      }
      this.beneKeyIdToDelete = 0;
      this.beneTypeToDelete = '';
      this.beneFullNameToDelete = '';
      this.showDeleteWarning = false;
      try {
        const fullName = beneObjToDel?.[0].fullName?.replaceAll(' ', '_');
        const tempDynatraceString = `PC2_UpdateBenf_Delete_Policynum-${this.currentPolicy?.contractId}_BeneficiaryType-${this.beneTypeToDelete}_Name-${fullName}`;
        // const tempStr = 'PC2_UpdateBenf_Edit_Policynum-' + <policy>_BeneficiaryType-[P,C,S,H]_Name-<Full Name - first 30 characters, replace spaces with underlines>
        const i = DynatraceClient.enterAction(tempDynatraceString);
        DynatraceClient.leaveAction(i);
      } catch (_error) {
        /* empty */
      }
    },
    editBeneficiary(bene: IGetBeneficiariesResponse) {
      this.$emit('set-beneficiary', bene);
      this.policyStore.beneficiaryStep = 3;
      try {
        const fullName = bene.fullName.replaceAll(' ', '_');
        const tempDynatraceString = `PC2_UpdateBenf_Edit_Policynum-${this.currentPolicy?.contractId}_BeneficiaryType-${bene.beneficiaryType}_Name-${fullName}`;
        // const tempStr = 'PC2_UpdateBenf_Edit_Policynum-' + <policy>_BeneficiaryType-[P,C,S,H]_Name-<Full Name - first 30 characters, replace spaces with underlines>
        const i = DynatraceClient.enterAction(tempDynatraceString);
        DynatraceClient.leaveAction(i);
      } catch (_error) {
        /* empty */
      }
    },
    hideWarningDialog() {
      this.showDeleteWarning = false;
      const beneId = this.beneKeyIdToDelete;
      const beneType = this.beneTypeToDelete;
      let beneObjToDel = null;
      if (beneType === 'P') {
        beneObjToDel = this.beneficiaryPrimary.filter(
          (ben: IGetBeneficiariesResponse) => ben.beneKeyId === beneId
        );
      } else if (beneType === 'C') {
        beneObjToDel = this.beneficiaryPrimaryContingent.filter(
          (ben: IGetBeneficiariesResponse) => ben.beneKeyId === beneId
        );
      } else if (beneType === 'S') {
        beneObjToDel = this.beneficiarySpouse.filter(
          (ben: IGetBeneficiariesResponse) => ben.beneKeyId === beneId
        );
      } else if (beneType === 'H') {
        beneObjToDel = this.beneficiarySpouseContingent.filter(
          (ben: IGetBeneficiariesResponse) => ben.beneKeyId === beneId
        );
      }
      try {
        const fullName = beneObjToDel?.[0].fullName?.replaceAll(' ', '_');
        const tempDynatraceString = `PC2_UpdateBenf_CancelDelete_Policynum-${this.currentPolicy?.contractId}_BeneficiaryType-${this.beneTypeToDelete}_Name-${fullName}`;
        // const tempStr = 'PC2_UpdateBenf_Edit_Policynum-' + <policy>_BeneficiaryType-[P,C,S,H]_Name-<Full Name - first 30 characters, replace spaces with underlines>
        const i = DynatraceClient.enterAction(tempDynatraceString);
        DynatraceClient.leaveAction(i);
      } catch (_error) {
        /* empty */
      }
    },
    async closeThisPage() {
      this.policyStore.scrollToPolicyDetails = 'beneficiary';
      this.policyStore.beneficiaryStep = -1;
      await this.$router?.push({
        name: RouteNames.POLICY_DETAILS,
        params: { contractId: this.selectedPolicyIndex },
      });
      try {
        const tempDynatraceString = `PC2_UpdateBenf_Cancel_Policynum-${this.currentPolicy?.contractId}`;
        // const tempStr = 'PC2_UpdateBenf_Edit_Policynum-' + <policy>_BeneficiaryType-[P,C,S,H]_Name-<Full Name - first 30 characters, replace spaces with underlines>
        const i = DynatraceClient.enterAction(tempDynatraceString);
        DynatraceClient.leaveAction(i);
      } catch (_error) {
        /* empty */
      }
    },
    async goToGuide() {
      await this.openInNewWindow({
        url: 'https://assets.contentstack.io/v3/assets/blt1dedeb682e8df2a2/blt453e8a85ee22ed66/How_to_Choose_Beneficiaries_Letter.pdf',
        target: '_blank',
      });
    },
    submitChanges() {
      if (this.beneficiariesTotalPrimaryPrimary !== 100) {
        // Primary Primary check
        this.displayErrorDialogDuringSubmitClick = true;
      }
      if (this.beneficiaryPrimaryContingent && this.beneficiaryPrimaryContingent.length > 0) {
        // Primary Contingent Data check
        if (this.beneficiariesTotalPrimaryContingent !== 100) {
          // Primary Contingent sum not 100 check
          this.displayErrorDialogDuringSubmitClick = true;
        }
      }
      if (this.showSpouseSection) {
        // We check in beneficiary response if there was spouse
        if (this.beneficiariesTotalSpousePrimary !== 100) {
          // Spouse Primary sum not 100 check
          this.displayErrorDialogDuringSubmitClick = true;
        }
        if (this.beneficiarySpouseContingent && this.beneficiarySpouseContingent.length > 0) {
          // Spouse contingent data check
          if (this.beneficiariesTotalSpouseContingent !== 100) {
            // Spouse Contingent sum not 100 check
            this.displayErrorDialogDuringSubmitClick = true;
          }
        }
      }
      if (
        this.invalidBeneficiaryPrimary ||
        this.invalidBeneficiaryPrimaryContingent ||
        this.invalidBeneficiarySpouse ||
        this.invalidBeneficiarySpouseContingent
      ) {
        this.displayErrorDialogDuringSubmitClick = true;
      }
      if (this.displayErrorDialogDuringSubmitClick) {
        return;
      }
      // Fix the null for country
      if (this.beneficiaryPrimary) {
        const bp = this.beneficiaryPrimary;
        bp.forEach((item: IGetBeneficiariesResponse) => {
          item.address.country = this.countryToUse;
        });
        this.setBeneficiaryPrimary(bp);
      }
      if (this.beneficiaryPrimaryContingent) {
        const bpc = this.beneficiaryPrimaryContingent;
        bpc.forEach((item: IGetBeneficiariesResponse) => {
          item.address.country = this.countryToUse;
        });
        this.setBeneficiaryPrimaryContingent(bpc);
      }
      if (this.beneficiarySpouse) {
        const bs = this.beneficiarySpouse;
        bs.forEach((item: IGetBeneficiariesResponse) => {
          item.address.country = this.countryToUse;
        });
        this.setBeneficiarySpouse(bs);
      }
      if (this.beneficiarySpouseContingent) {
        const bsc = this.beneficiarySpouseContingent;
        bsc.forEach((item: IGetBeneficiariesResponse) => {
          item.address.country = this.countryToUse;
        });
        this.setBeneficiarySpouseContingent(bsc);
      }

      // Show confirmation page
      this.policyStore.beneficiaryStep = 4;
      try {
        const i = DynatraceClient.enterAction('updateBeneficiaries_submit');
        DynatraceClient.leaveAction(i);
        const tempDynatraceString = `PC2_UpdateBenf_Submit_Policynum-${this.currentPolicy?.contractId}`;
        // const tempStr = 'PC2_UpdateBenf_Edit_Policynum-' + <policy>_BeneficiaryType-[P,C,S,H]_Name-<Full Name - first 30 characters, replace spaces with underlines>
        const j = DynatraceClient.enterAction(tempDynatraceString);
        DynatraceClient.leaveAction(j);
      } catch (_error) {
        /* empty */
      }
    },
    hideOriginVorTwithNoIrrevocable() {
      this.showOriginVorTwithNoIrrevocable = false;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    if (this.beneficiaryStep === 1) {
      if (
        !this.beneficiaryHasOriginVorTWithIrrevocable &&
        this.beneficiaryHasOriginVorT &&
        !this.isBeneficiaryDataDirty &&
        !this.comingFromEditBeneficiary
      ) {
        this.showOriginVorTwithNoIrrevocable = true;
      }
    }
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.cursor_pointer {
  cursor: pointer;
}

.redbar {
  border-top: 8px solid #ec5555;
}

.bluebar {
  border-top: 8px solid #3399ff;
}

.grayBackground {
  background-color: #f9f9f9;
}

.dialog_header_label {
  font-size: 28px;
  font-weight: bold;
  color: #333333;
}

.dialog_header_label_mobile {
  font-size: 14px;
  font-weight: bold;
  color: #333333;
}

.dialog_close_icon {
  font-size: 40px !important;
}

.dialog_close_icon_mobile {
  font-size: 25px !important;
  margin-top: -5px;
}

.dialog_body_text {
  font-size: 18px;
  font-weight: regular;
  padding-bottom: 80px;
}

.dialog_body_text_mobile {
  font-size: 13px;
  font-weight: regular;
  padding-bottom: 40px;
}

.dialog_button {
  margin-top: 50px;
  font-size: 20px;
  font-weight: bold;
}

.dialog_button_mobile {
  margin-top: 30px;
  font-size: 14px;
  font-weight: bold;
}

.help-link {
  font-weight: 600;
  color: #02579e !important;
  text-decoration: none;
  cursor: pointer;
}

.dividerAboveTotal {
  height: 20px;
  border-top: 1px solid #d4d4d4;
}

.bottomBorderGray {
  border-bottom: 1px solid #cccccc;
}

.layoutHeightVertCenterData {
  line-height: 3;
  height: 80px;
}

.layoutHeightVertCenterTotal {
  line-height: 1.2;
  padding-top: 10px;
  padding-bottom: 10px;
}

.delete_right_space {
  padding-right: 17px;
  cursor: pointer;
}

.link_text {
  cursor: pointer;
}

.max-width-40 {
  max-width: 40px !important;
}

.padding-space-left-40 {
  padding-left: 40px;
}

.marginTop15 {
  margin: 15px 0 0 0;
}

.paddingLRMobile {
  padding-left: 10px;
  padding-right: 10px;
}

.paddingLRDesktop {
  padding-left: 20px;
  padding-right: 20px;
}

.paddingLDesktop {
  padding-left: 20px;
}

.mustEqual100 {
  color: #666666;
}

.mustEqual100Error {
  color: red;
}

.bkgrndColorDarkGray {
  background-color: #f5f5f5;
}

.bkgrndColorLightGray {
  background-color: #f9f9f9;
}

.bkgrndColorLightWhite {
  background-color: #ffffff;
}

.bold600 {
  font-weight: 600;
}

.tdecor {
  text-decoration: underline;
}

.linkToAddBeneficiary {
  font-size: 14px;
  font-weight: bold;
  color: #02579e;
  margin-left: 5px;
}

.linkTextWOUnderline {
  color: #02579e;
  cursor: pointer;
}

.linkText {
  color: #02579e;
  cursor: pointer;
  text-decoration: underline;
}

.noLinkText {
  text-decoration: none;
}

.move-right {
  float: right;
}

.bkgrnd-color-white {
  background-color: #ffffff;
}

.bkgrnd-color-blue-white {
  background-color: #f5f7fa;
}

.blue-bkgrnd {
  background-color: #e2f0fe;
  border-top: 1px solid #d4d4d4;
}

.red-bkgrnd {
  background-color: #fdecec;
  border-top: 1px solid #dd3333;
}

.redText {
  color: #dd3333;
}

.blackText {
  color: #424242;
}

.buttonFormat {
  width: 300px;
  height: 44px;
  font-size: 18px;
  font-weight: 600;
}

.buttonFormat_mobile {
  width: 180px;
  height: 44px;
  font-size: 14px;
  font-weight: 600;
}

.sm-pl-5 {
  padding-left: 40px;
}

.pad-left-md {
  padding-left: 12px;
}

.pad-right-md {
  padding-right: 12px;
}

.blue-border {
  border: solid 2px #2196f3;
  cursor: pointer;
}

.select-address {
  color: #2196f3 !important;
}

:deep(label.v-label--active) {
  font-weight: 500;
  color: #333;
}

:deep(div.v-input) {
  padding-bottom: 12px;
}

h3.heading_three.font-weight-medium {
  font-weight: 500 !important;
}

.font-size-md {
  font-size: 16px !important;
}

.inlineText {
  display: inline-text;
}

button.short {
  height: 40px !important;
  text-transform: none !important;
  box-shadow: none !important;
  border: 1px #063562 solid;
  width: auto !important;
}

.textOverflow {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.heavyDivider {
  border: 2px solid #adadad;
}

.cssBeneficiaryPercent {
  font-size: 18px !important;
  padding: 5px 0 5px 0 !important;
  line-height: 1 !important;
  width: 52px;
  position: relative;
  margin: auto !important;
  margin-top: 5px !important;
  text-align: right !important;
  display: inline-block !important;
}

.fixedAllocationPercentMargin {
  margin-top: 10px;
  display: block;
}

.iconSpace {
  padding-left: 29px;
}

.beneficiary-card.v-card {
  height: 100%;
  position: relative;
}

.allocation-percentage-width {
  width: 136.5px;
}

@media (max-width: 440px) {
  .beneficiary-card.v-card {
    width: 100vw;
    left: -1rem;
  }
  .header-title-width {
    width: 225px;
  }
  .allocation-percentage-width {
    width: 99.5px;
  }
}
</style>
